var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon bubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.3--Elements",
    transform: "translate(-771.000000, -405.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(771.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#EBA601",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6706199,12.8531253 L12.471233,7.25153833 C11.5657112,6.80069584 10.4748184,6.96619832 9.74364733,7.66534819 C9.01247624,8.36449806 8.7980098,9.44718738 9.20741167,10.3724225 L11.1273066,14.6696399 C11.2153052,14.8795117 11.2153052,15.1159541 11.1273066,15.3258258 L9.20741167,19.6230433 C8.87698855,20.3655897 8.94459634,21.2249558 9.38706737,21.9066562 C9.82953839,22.5883566 10.5867759,22.9998023 11.3992917,23 C11.773856,22.9962609 12.1428423,22.9087679 12.4792326,22.7439275 L23.6786195,17.1423405 C24.4887783,16.7346493 25,15.9049337 25,14.9977329 C25,14.0905321 24.4887783,13.2608165 23.6786195,12.8531253 L23.6706199,12.8531253 Z M22.9586589,15.7099347 L11.759272,21.3115216 C11.4581024,21.456179 11.0987818,21.3983779 10.8581315,21.1665623 C10.6174812,20.9347466 10.5461864,20.5777408 10.6793311,20.2712269 L12.5912264,15.9740095 C12.6159764,15.9166264 12.6373452,15.8578425 12.6552229,15.7979596 L18.1669212,15.7979596 C18.6087248,15.7979596 18.9668774,15.4396859 18.9668774,14.9977329 C18.9668774,14.5557799 18.6087248,14.1975062 18.1669212,14.1975062 L12.6552229,14.1975062 C12.6373452,14.1376233 12.6159764,14.0788393 12.5912264,14.0214563 L10.6793311,9.72423887 C10.5461864,9.41772501 10.6174812,9.06071921 10.8581315,8.82890353 C11.0987818,8.59708785 11.4581024,8.53928678 11.759272,8.68394414 L22.9586589,14.2855311 C23.2258173,14.4224467 23.3938667,14.6974535 23.3938667,14.9977329 C23.3938667,15.2980123 23.2258173,15.5730191 22.9586589,15.7099347 Z",
    id: "Shape",
    fill: "#EBA601",
    fillRule: "nonzero",
    transform: "translate(17.000000, 15.000000) rotate(-45.000000) translate(-17.000000, -15.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestSent);
export default __webpack_public_path__ + "static/media/RequestSent.ac742df4a304a353fac0389b7578d59c.svg";
export { ForwardRef as ReactComponent };